import VerifySuccessPage from './verify-success-page';

export default VerifySuccessPage;
